/** Exponential backoff for WebSocket reconnect. attempt is 0-based. */
export function nextWsRetryMs(attempt: number): number {
  const exp = Math.min(Math.max(0, attempt), 6);
  return Math.min(60_000, 1_000 * 2 ** exp);
}
